import { Button, FormControl, TextField, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { useState } from 'react';

type MessageInputFieldProps = {
    disabled: boolean;
    caseStage: string;
    handleSave: (messageText: string) => void;
};
const MessageInputField = ({ handleSave, disabled, caseStage }: MessageInputFieldProps) => {
    const [message, setMessage] = useState('');

    const onMessageSubmit = () => {
        if (message === '') {
            return;
        } else {
            handleSave(message);
        }
        setMessage('');
    };

    return (
        <>
            <Typography variant="h1" sx={{ marginBottom: 1, fontSize: '1rem' }}>
                Case Messages
            </Typography>
            {disabled
                ? null
                : !caseStage.includes('Cosign') && (
                      <FormControl fullWidth>
                          <StyledTextField
                              id="message-text-field"
                              placeholder={`Type your message ${'here.'}`}
                              multiline
                              disabled={disabled}
                              value={message}
                              onChange={(
                                  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
                              ) => setMessage(e.target.value)}
                              rows={4}
                          />
                          <Button
                              variant="contained"
                              disabled={disabled}
                              onClick={onMessageSubmit}
                              sx={{ margin: '0.625rem 0', width: '9.375rem' }}>
                              Send Message
                          </Button>
                      </FormControl>
                  )}
        </>
    );
};

export const StyledTextField = styled(TextField)`
    .MuiInputBase-root {
        font-size: 0.813rem;
    }
`;

export default MessageInputField;
